import React from 'react';

import FinalTermsPage from './FinalTermsPage';
import GoldMembershipPage from './GoldMembershipPage';
import { trackPageView } from 'src/clients/tracking';

export type FinalTermsPageType = 'FINAL_TERMS' | 'GOLD_MEMBERSHIP';

const FinalTermsRouter = () => {
  const [currentPage, setCurrentPage] = React.useState<FinalTermsPageType>('FINAL_TERMS');

  React.useEffect(() => {
    switch (currentPage) {
      case 'GOLD_MEMBERSHIP':
        trackPageView('FinalTermsGoldMembership');
        break;
      default:
        break;
    }
  }, [currentPage]);

  const onNext = React.useCallback(() => {
    setCurrentPage('GOLD_MEMBERSHIP');
  }, []);

  return (
    <>
      {currentPage === 'FINAL_TERMS' && <FinalTermsPage onNext={onNext} />}
      {currentPage === 'GOLD_MEMBERSHIP' && <GoldMembershipPage />}
    </>
  );
};

export default FinalTermsRouter;
